module.exports = __webpack_public_path__ + "static/img/lotte-tms.6c39e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/lotte-tms.jpg
// module id = WGmu
// module chunks = 0